import type { Channel, Coverage, OfferViewModel } from "@/api_client";

import { getEcommerceCheckout } from "./data/ecommerce";
import insuranceInfo from "./data/insuranceInfo";
import objectInfo from "./data/objectInfo";
import processInfo from "./data/processInfo";
import productInfo from "./data/productInfo";
import type { CheckoutEvent } from "./types/types";

export const createCheckoutEvent = (
  contextId: string,
  offer: OfferViewModel,
  channel: Channel,
  coverageContent: Record<string, Coverage> | undefined,
): CheckoutEvent | undefined => {
  if (!offer?.quotes) {
    return;
  }
  const committedQuotes = offer.quotes.filter((q) => !!q.committedAt);
  const productInfoList = committedQuotes.map((product) =>
    productInfo.getProductInfo(product, channel),
  );
  const insuranceInfoList = committedQuotes.map((product) =>
    insuranceInfo.getInsuranceInfo(contextId, product, coverageContent),
  );
  const objectInfoList = committedQuotes
    .map((product) =>
      objectInfo.getObjectInfo(
        offer.enigmatized?.policyHolder,
        product,
        product.id && offer.enigmatized?.quotes
          ? offer.enigmatized.quotes[product.id]
          : undefined,
      ),
    )
    .filter((oi) => oi !== undefined);

  return {
    event: "Checkout",
    productInfo: productInfoList,
    insuranceInfo: insuranceInfoList,
    processInfo: processInfo.getProcessInfo("checkout"),
    ecommerce: getEcommerceCheckout(offer.quotes, channel, coverageContent),
    objectInfo: objectInfoList,
  };
};
